// extracted by mini-css-extract-plugin
export default {"card":"c6-z"};